// Dynamics-Marketingboxen: Daten laden, Darstellung aber mit der bestehenden
// EventBox/Marketing-Komponentenstruktur aufbauen. Kein fertiger Dynamics-Teaser
// wird ins Frontend uebernommen; Headline, Bild, Liste und Button werden getrennt
// gerendert.

// try/catch: ohne esbuild-define würde process.env das gesamte Bundle (inkl. htmx-Init) crashen
const iwwMarketingBoxBasisUrl = (function () {
    if (window.location.hostname.endsWith('.internal')) {
        return 'https://productrecommender.iww.internal';
    }
    try {
        return process.env.PRODUCTRECOMMENDER_URL || 'https://productrecommender.iww.de';
    } catch (e) {
        return 'https://productrecommender.iww.de';
    }
})();

function iwwMarketingBoxDeliveryUrl(element) {
    const type = element.getAttribute('data-marketingbox-type') || 'online-advertising';
    const normalizedType = type === 'event-advertising' ? 'event-advertising' : 'online-advertising';
    return iwwMarketingBoxBasisUrl + '/api/v1/marketingbox/' + normalizedType + '/delivery';
}

function iwwMarketingBoxImBackend(element) {
    return element.hasAttribute('data-__neos-node-contextpath')
        || document.body.classList.contains('neos-backend')
        || document.querySelector('[data-__neos-node-contextpath]') !== null;
}

function iwwMarketingBoxIstEvent(box) {
    return box && (box.marketingBoxType === 'eventAdvertising' || box.boxType === 'Veranstaltungs-Werbung');
}

function iwwMarketingBoxEscape(value) {
    return String(value === null || value === undefined ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function iwwMarketingBoxPlatzhalter(inhalt, text) {
    inhalt.innerHTML = '<div class="rounded-sm border border-dashed border-surface-border bg-surface-elevated-background p-4 text-sm text-neutral-subtle">'
        + iwwMarketingBoxEscape(text) + '</div>';
}

function iwwMarketingBoxBulletHtml(value) {
    return iwwMarketingBoxRichTextHtml(value);
}

function iwwMarketingBoxRichTextHtml(value, description = false) {
    // Analog zur FreeTrial-Shopbeschreibung: nur neue Textknoten und b/i/u/br.
    // Bei Event-Beschreibungen auch die eingegebene Absatz-/Listenstruktur erhalten.
    // Keine Quellknoten, Attribute oder beliebigen Dynamics-Styles uebernehmen.
    let html = String(value || '');
    if (description && !/<[a-z][^>]*>/i.test(html)) html = html.replace(/\r\n|\r|\n/g, '<br>');
    const source = new DOMParser().parseFromString(html, 'text/html');
    const result = document.createElement('div');
    const appendBreak = target => {
        if (target.hasChildNodes() && target.lastChild.nodeName !== 'BR') {
            target.append(document.createElement('br'));
        }
    };
    const append = (node, target) => {
        if (node.nodeType === Node.TEXT_NODE) {
            target.append(document.createTextNode(node.textContent));
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.namespaceURI !== 'http://www.w3.org/1999/xhtml'
            || ['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'TEMPLATE', 'NOSCRIPT'].includes(node.tagName)) return;
        if (node.tagName === 'BR') {
            target.append(document.createElement('br'));
            return;
        }
        const block = ['P', 'DIV', 'LI'].includes(node.tagName);
        if (block && !description) appendBreak(target);
        let inline = target;
        if (description && ['P', 'DIV', 'UL', 'OL', 'LI'].includes(node.tagName)) {
            inline = document.createElement(node.tagName.toLowerCase());
            target.append(inline);
        }
        const weight = node.style.fontWeight;
        const italic = node.style.fontStyle;
        if (['B', 'STRONG'].includes(node.tagName) || ['bold', 'bolder'].includes(weight) || parseInt(weight, 10) >= 600) {
            const bold = document.createElement('b');
            inline.append(bold);
            inline = bold;
        }
        if (['I', 'EM'].includes(node.tagName) || italic === 'italic' || italic.startsWith('oblique')) {
            const emphasis = document.createElement('i');
            inline.append(emphasis);
            inline = emphasis;
        }
        const decoration = node.style.textDecorationLine || node.style.textDecoration;
        if (node.tagName === 'U' || decoration.split(/\s+/).includes('underline')) {
            const underline = document.createElement('u');
            inline.append(underline);
            inline = underline;
        }
        Array.from(node.childNodes).forEach(child => append(child, inline));
        if (block && !description) appendBreak(target);
    };
    Array.from(source.body.childNodes).forEach(node => append(node, result));
    // Fuehrende Aufzaehlungszeichen auch innerhalb formatierter Textknoten entfernen.
    const texts = document.createTreeWalker(result, NodeFilter.SHOW_TEXT);
    let text;
    while (!description && (text = texts.nextNode())) {
        if (!text.textContent.trim()) continue;
        text.textContent = text.textContent.replace(/^\s*[-•✓✔]\s*/u, '');
        break;
    }
    while (!description && result.lastChild && (result.lastChild.nodeName === 'BR'
        || (result.lastChild.nodeType === Node.TEXT_NODE && !result.lastChild.textContent.trim()))) {
        result.lastChild.remove();
    }
    return result.textContent.trim() ? result.innerHTML : '';
}

function iwwMarketingBoxHeadlineHtml(box) {
    if (!box.headline) return '';
    // Iww.Presentation:Marketing.Headline type="box"; Farbe erbt von BoxContent.
    return '<h3 class="mt-1 cursor-pointer text-xl font-medium sm:text-2xl text-left">'
        + iwwMarketingBoxEscape(box.headline) + '</h3>';
}

function iwwMarketingBoxOverlineHtml(box) {
    const overline = iwwMarketingBoxIstEvent(box) ? (box.eventType || box.overline) : box.overline;
    if (!overline) return '';

    // Bei Veranstaltungsboxen ist iww_eventtype die fachliche Kategorisierung.
    // overline bleibt Fallback fuer bereits gepflegte/alte Datensaetze.
    return '<h4 class="cursor-pointer text-lg sm:text-xl mb-0 text-white text-left">'
        + iwwMarketingBoxEscape(overline) + '</h4>';
}

function iwwMarketingBoxListeHtml(box) {
    if (iwwMarketingBoxIstEvent(box)) {
        // Alte API-Antworten mit mehreren Eintraegen ebenfalls ohne Haken ausgeben.
        const description = iwwMarketingBoxRichTextHtml((box.bulletPoints || []).join('<br>'), true);
        return description ? '<div class="iww-marketingbox-description mt-4 text-base">' + description + '</div>' : '';
    }
    const items = (box.bulletPoints || []).slice(0, 3)
        .map(iwwMarketingBoxBulletHtml)
        .filter(Boolean);

    if (!items.length) return '';

    return '<ul class="mt-4 space-y-2 text-base">' + items.map(function (item) {
        return '<li class="flex items-center gap-2">'
            + '<span class="text-white before:font-icomoon before:content-checkmark inline-flex size-4 items-center justify-center text-sm font-semibold"></span>'
            + '<span>' + item + '</span>'
            + '</li>';
    }).join('') + '</ul>';
}

function iwwMarketingBoxIconHtml(type) {
    const attributes = 'class="size-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

    if (type === 'monitor') {
        return '<svg ' + attributes + '><rect x="3" y="4" width="18" height="12" rx="2"></rect><path d="M8 20h8M12 16v4"></path></svg>';
    }
    if (type === 'pin') {
        return '<svg ' + attributes + '><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>';
    }
    if (type === 'calendar') {
        return '<svg ' + attributes + '><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M16 3v4M8 3v4M3 10h18"></path></svg>';
    }
    if (type === 'euro') {
        return '<svg ' + attributes + '><path d="M18 7.5a6 6 0 1 0 0 9M5 10h9M5 14h8"></path></svg>';
    }
    if (type === 'award') {
        return '<svg ' + attributes + '><circle cx="12" cy="8" r="5"></circle><path d="m8.5 12-1 9 4.5-2.5L16.5 21l-1-9"></path></svg>';
    }
    if (type === 'person') {
        return '<svg ' + attributes + '><circle cx="12" cy="8" r="4"></circle><path d="M4.5 21a7.5 7.5 0 0 1 15 0"></path></svg>';
    }
    return '';
}

function iwwMarketingBoxEventModeValue(box) {
    const explicit = String(box.eventMode || '').trim();
    if (explicit !== '') return explicit;

    // Fallback fuer bereits synchronisierte Datensaetze, bei denen iww_eventart
    // noch leer ist. Sobald Dynamics das Feld liefert, hat eventMode immer Vorrang.
    const source = [box.backgroundStyle, box.eventType, box.overline]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

    if (source.includes('hybrid')) return 'Hybrid';
    if (source.includes('präsenz') || source.includes('praesenz')) return 'Präsenz';
    if (source.includes('digital') || source.includes('online') || source.includes('webinar')) return 'Digital';

    return '';
}

function iwwMarketingBoxEventMode(box) {
    const normalized = iwwMarketingBoxEventModeValue(box).toLowerCase();

    if (normalized === 'digital' || normalized === 'online') return 'digital';
    if (normalized === 'präsenz' || normalized === 'praesenz' || normalized === 'präsenzveranstaltung' || normalized === 'praesenzveranstaltung') return 'presence';
    if (normalized === 'hybrid') return 'hybrid';
    return normalized ? 'other' : '';
}

function iwwMarketingBoxMetaItemHtml(icon, text, extraClass) {
    if (!text) return '';
    return '<span class="inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-sm text-white/90 '
        + (extraClass || '') + '">'
        + iwwMarketingBoxIconHtml(icon)
        + '<span>' + iwwMarketingBoxEscape(text) + '</span>'
        + '</span>';
}

function iwwMarketingBoxEventMetaHtml(box) {
    if (!iwwMarketingBoxIstEvent(box)) return '';

    const mode = iwwMarketingBoxEventMode(box);
    const modeLabel = iwwMarketingBoxEventModeValue(box);
    const location = String(box.eventLocation || '').trim();
    const schedule = box.eventSchedule && box.eventSchedule.label ? String(box.eventSchedule.label) : '';
    const price = box.eventPrice !== null && box.eventPrice !== undefined ? String(box.eventPrice).trim() : '';
    const cmePoints = Number.isFinite(Number(box.cmePoints)) && Number(box.cmePoints) > 0
        ? Number(box.cmePoints) + ' CME-' + (Number(box.cmePoints) === 1 ? 'Punkt' : 'Punkte')
        : '';

    let modeHtml = '';
    if (mode === 'digital') {
        modeHtml = iwwMarketingBoxMetaItemHtml('monitor', modeLabel || 'Digital');
    } else if (mode === 'presence') {
        modeHtml = iwwMarketingBoxMetaItemHtml('pin', location ? (modeLabel || 'Präsenz') + ' · ' + location : (modeLabel || 'Präsenz'));
    } else if (mode === 'hybrid') {
        modeHtml = iwwMarketingBoxMetaItemHtml('monitor', modeLabel || 'Hybrid')
            + (location ? iwwMarketingBoxMetaItemHtml('pin', location) : '');
    } else if (modeLabel) {
        modeHtml = iwwMarketingBoxMetaItemHtml('monitor', modeLabel);
    }

    // Fuer digitale Veranstaltungen "Online" nicht doppelt ausgeben.
    if (mode === 'digital' && location && location.toLowerCase() !== 'online') {
        modeHtml += iwwMarketingBoxMetaItemHtml('pin', location);
    }

    const items = modeHtml
        + iwwMarketingBoxMetaItemHtml('calendar', schedule)
        + iwwMarketingBoxMetaItemHtml('euro', price)
        + iwwMarketingBoxMetaItemHtml('award', cmePoints);

    return items ? '<div class="mt-3 flex flex-wrap items-center gap-2">' + items + '</div>' : '';
}

function iwwMarketingBoxSpeakerHtml(box) {
    if (!iwwMarketingBoxIstEvent(box) || !box.speaker) return '';

    return '<div class="mt-4 inline-flex items-center gap-2 text-sm text-white/80">'
        + iwwMarketingBoxIconHtml('person')
        + '<span>' + iwwMarketingBoxEscape(box.speaker) + '</span>'
        + '</div>';
}

function iwwMarketingBoxButtonHtml(box) {
    const primary = box.targetUrl && box.ctaText
        ? '<a class="px-6 py-4 rounded-full inline-flex justify-center items-center text-center text-base font-medium leading-none transition-all hover:scale-105 bg-white hover:bg-white/80 text-primary-on-surface"'
            + ' href="' + iwwMarketingBoxEscape(box.targetUrl) + '" target="' + (box.linkTarget === '_blank' ? '_blank' : '_self') + '"'
            + (box.linkTarget === '_blank' ? ' rel="noopener noreferrer"' : '') + '>'
            + iwwMarketingBoxEscape(box.ctaText) + '</a>'
        : '';

    const secondary = iwwMarketingBoxIstEvent(box) && box.secondaryTargetUrl && box.secondaryCtaText
        ? '<a class="inline-flex items-center border-b border-transparent text-sm font-medium text-white/80 transition-colors hover:border-white/60 hover:text-white"'
            + ' href="' + iwwMarketingBoxEscape(box.secondaryTargetUrl) + '">'
            + iwwMarketingBoxEscape(box.secondaryCtaText) + '</a>'
        : '';

    if (!primary && !secondary) return '';
    return '<div class="mt-5 flex flex-wrap items-center gap-4">' + primary + secondary + '</div>';
}

function iwwMarketingBoxBildHtml(box) {
    if (!box.productImageUrl) return '';

    const imageFormat = String(box.imageFormat || '').toLowerCase();
    const landscape = imageFormat.indexOf('quer') !== -1 || imageFormat.indexOf('landscape') !== -1 || imageFormat.indexOf('gruppe') !== -1;
    const imageClass = landscape
        ? 'block h-auto w-auto max-w-full max-h-44'
        : 'block h-auto w-auto max-w-full max-h-64';
    const frameClass = 'w-fit min-w-0 max-w-full overflow-hidden rounded-3xl' + (landscape ? ' md:max-w-md' : '');
    const wrapperClass = landscape
        ? 'flex w-full items-center justify-start md:w-5/12 md:justify-end md:items-center mt-3 md:mt-0'
        : 'flex w-full items-center justify-start md:w-auto md:justify-end md:items-end mt-3 md:mt-0 md:mr-11';

    // Das Bild nicht direkt als Flex-Item mit object-contain skalieren:
    // Bildinhalt und abgerundete Kante sollen dieselben Abmessungen haben.
    return '<div class="' + wrapperClass + '">'
        + '<div class="' + frameClass + '">'
        + '<img class="' + imageClass + ' rounded-3xl" src="' + iwwMarketingBoxEscape(box.productImageUrl) + '" alt="'
        + iwwMarketingBoxEscape(box.headline || box.internalName || 'Marketingbox') + '" loading="lazy"/>'
        + '</div></div>';
}

function iwwMarketingBoxPanelHtml(box, index) {
    const eventClass = iwwMarketingBoxIstEvent(box)
        ? ' data-event-mode="' + iwwMarketingBoxEscape(iwwMarketingBoxEventMode(box)) + '"'
        : '';

    return '<div data-event-panel' + eventClass + ' class="' + (index === 0 ? '' : 'hidden') + '">'
        + '<div class="flex flex-col gap-6 md:flex-row md:items-start md:justify-between md:gap-8">'
        + '<div class="min-w-0 flex-1 text-white">'
        + iwwMarketingBoxOverlineHtml(box)
        + iwwMarketingBoxHeadlineHtml(box)
        + iwwMarketingBoxEventMetaHtml(box)
        + iwwMarketingBoxListeHtml(box)
        + iwwMarketingBoxSpeakerHtml(box)
        + iwwMarketingBoxButtonHtml(box)
        + '</div>'
        + iwwMarketingBoxBildHtml(box)
        + '</div>'
        + '</div>';
}

function iwwMarketingBoxTabHtml(box, index) {
    const active = index === 0;
    const stateClass = active
        ? 'text-white border-white/30 bg-white/10 shadow-lg shadow-black/10 backdrop-blur-lg'
        : 'text-white/80 border-transparent hover:text-white hover:border-white/10 hover:bg-white/10 hover:shadow-sm hover:shadow-black/5';
    const labelState = active ? 'text-white' : 'text-white/50';
    const isEvent = iwwMarketingBoxIstEvent(box);
    const label = isEvent ? (box.tabSubline || box.eventType || box.overline || '') : (box.overline || '');
    const title = isEvent ? (box.teaserTitle || box.tabTitle || box.headline || box.internalName || '') : (box.headline || box.internalName || '');

    return '<li class="flex basis-full justify-center sm:basis-0 sm:min-w-0 sm:flex-1 sm:justify-start">'
        + '<button type="button" role="tab" data-iww-marketingbox-tab-index="' + index + '" ' + (active ? 'aria-selected="true" ' : 'aria-selected="false" ')
        + 'class="flex w-full cursor-pointer flex-col items-start justify-center rounded-[16px] border px-4 py-3 text-left text-sm leading-normal transition-all duration-300 ease-out sm:rounded-[1.75rem] sm:px-6 sm:py-3.5 sm:text-base ' + stateClass + '">'
        + '<span class="mb-1 line-clamp-1 text-xs font-semibold tracking-wide ' + labelState + '">'
        + iwwMarketingBoxEscape(label) + '</span>'
        + '<span class="line-clamp-2 text-sm leading-snug sm:text-base">'
        + iwwMarketingBoxEscape(title) + '</span>'
        + '</button></li>';
}

function iwwMarketingBoxTabsHtml(boxen) {
    if (boxen.length <= 1) return '';

    return '<div data-iww-marketingbox-tabs class="mt-6 md:mt-8">'
      + '<ul class="flex w-full flex-wrap items-stretch justify-center gap-1 rounded-[20px] border border-white/20 bg-white/10 px-1 py-1 text-sm shadow-lg shadow-black/10 backdrop-blur-lg sm:flex-nowrap sm:gap-1.5 sm:rounded-[2.25rem] sm:px-1.5 sm:py-1.5">'
      + boxen.map(iwwMarketingBoxTabHtml).join('')
      + '</ul></div>';
}

function iwwMarketingBoxBackendTabsFreigeben(inhalt) {
    const marketingBoxElement = inhalt.closest('[data-iww-marketingbox]');
    if (!marketingBoxElement || !iwwMarketingBoxImBackend(marketingBoxElement)) return;

    const tabsContainer = inhalt.querySelector('[data-iww-marketingbox-tabs]');
    if (!tabsContainer) return;

    // Neos 8.4 legt bei nicht inline-editierbaren Content-Nodes einen absolut
    // positionierten Overlay ueber das komplette Element. Dieser Overlay ist
    // fuer die Node-Auswahl richtig, blockiert aber Pointer-Events der Tabs.
    // Nur die Navigation wird ueber den Overlay gehoben; der restliche Teaser
    // bleibt weiterhin normal im Neos-Canvas auswaehlbar.
    tabsContainer.style.position = 'relative';
    tabsContainer.style.zIndex = '2147483646';
    tabsContainer.style.pointerEvents = 'auto';
}

function iwwMarketingBoxAktiviereTab(marketingBoxElement, index) {
    const panels = Array.from(marketingBoxElement.querySelectorAll('.iww-marketingbox-inhalt [data-event-panel]'));
    const tabs = Array.from(marketingBoxElement.querySelectorAll('[data-iww-marketingbox-tab-index]'));
    if (!panels.length || !tabs.length || index < 0 || index >= panels.length) return;

    const activeClasses = ['text-white', 'border-white/30', 'bg-white/10', 'shadow-lg', 'shadow-black/10', 'backdrop-blur-lg'];
    const inactiveClasses = ['text-white/80', 'hover:text-white', 'hover:border-white/10', 'hover:bg-white/10', 'hover:shadow-sm', 'hover:shadow-black/5'];

    tabs.forEach(function (tab, tabIndex) {
        const active = tabIndex === index;
        const label = tab.querySelector('span:first-child');

        activeClasses.forEach(function (className) { tab.classList.toggle(className, active); });
        inactiveClasses.forEach(function (className) { tab.classList.toggle(className, !active); });
        tab.classList.toggle('border-transparent', !active);

        tab.setAttribute('aria-selected', active ? 'true' : 'false');

        if (label) {
            label.classList.toggle('text-white', active);
            label.classList.toggle('text-white/50', !active);
        }
    });

    panels.forEach(function (panel, panelIndex) {
        panel.classList.toggle('hidden', panelIndex !== index);
    });
}

function iwwMarketingBoxTabEvent(event) {
    const target = event.target instanceof Element ? event.target.closest('[data-iww-marketingbox-tab-index]') : null;
    if (!target) return;

    const marketingBoxElement = target.closest('[data-iww-marketingbox]');
    if (!marketingBoxElement) return;

    // Neos faengt insbesondere Link-Klicks im Content-Canvas ab. Die Dynamics-
    // Tabs sind deshalb Buttons und reagieren zusaetzlich bereits auf pointerdown.
    // So funktioniert der Wechsel im Backend genauso wie im normalen Frontend.
    event.preventDefault();
    event.stopPropagation();

    const index = Number.parseInt(target.getAttribute('data-iww-marketingbox-tab-index') || '', 10);
    if (Number.isNaN(index)) return;
    iwwMarketingBoxAktiviereTab(marketingBoxElement, index);
}

function iwwMarketingBoxTabsDelegieren() {
    if (document.documentElement.getAttribute('data-iww-marketingbox-tabs-delegated') === 'true') return;
    document.documentElement.setAttribute('data-iww-marketingbox-tabs-delegated', 'true');

    // Auf window in der Capture-Phase reagieren: damit sind wir vor den
    // Neos-GuestFrame-Handlern, die Klicks zur Node-Auswahl verarbeiten.
    window.addEventListener('pointerdown', iwwMarketingBoxTabEvent, true);
    window.addEventListener('click', iwwMarketingBoxTabEvent, true);
}

function iwwMarketingBoxRender(inhalt, boxen) {
    // Wichtig: backgroundColor aus Dynamics wird hier bewusst NICHT verwendet.
    // Der Hintergrund ist die serverseitige KachelBox type="dark".
    inhalt.innerHTML = boxen.map(iwwMarketingBoxPanelHtml).join('') + iwwMarketingBoxTabsHtml(boxen);
    iwwMarketingBoxBackendTabsFreigeben(inhalt);

    // Die dynamischen Dynamics-Tabs werden bewusst ausschliesslich hier
    // gesteuert. Das generische marketing-box-tabs.js bleibt fuer die
    // serverseitig gerenderten EventBoxen zustaendig.
}

function iwwMarketingBoxLeertext(element) {
    if (element.getAttribute('data-befuellung') !== 'manuell') {
        return 'Keine passenden aktiven Marketingboxen gefunden.';
    }

    if ((element.getAttribute('data-marketingbox-type') || '') === 'event-advertising') {
        return 'Keine der ausgewählten Veranstaltungs-Werbeboxen ist aktuell ausspielbar (Status, Kampagnenzeitraum oder Veranstaltungstermin/Buchungsvorlauf).';
    }

    return 'Keine der ausgewählten Marketingboxen ist aktuell ausspielbar (Status oder Kampagnenzeitraum).';
}

function iwwMarketingBoxLade(element) {
    if (element.getAttribute('data-iww-marketingbox-initialisiert') === 'true') return;
    element.setAttribute('data-iww-marketingbox-initialisiert', 'true');

    const inhalt = element.querySelector('.iww-marketingbox-inhalt');
    if (!inhalt) return;

    const imBackend = iwwMarketingBoxImBackend(element);
    const parameter = new URLSearchParams();

    if (element.getAttribute('data-befuellung') === 'manuell') {
        const ids = element.getAttribute('data-boxen') || '';
        if (ids === '') {
            if (imBackend) {
                iwwMarketingBoxPlatzhalter(inhalt, 'Keine Marketingboxen ausgewählt – bitte im Inspector Boxen wählen.');
            } else {
                element.style.display = 'none';
            }
            return;
        }
        parameter.set('ids', ids);
    } else {
        const informationsdienste = element.getAttribute('data-informationsdienste') || '';
        const zielgruppen = element.getAttribute('data-zielgruppen') || '';
        if (informationsdienste !== '') parameter.set('informationsdienste', informationsdienste);
        if (zielgruppen !== '') parameter.set('zielgruppen', zielgruppen);
    }

    if (imBackend) iwwMarketingBoxPlatzhalter(inhalt, 'Marketingboxen werden geladen...');

    fetch(iwwMarketingBoxDeliveryUrl(element) + '?' + parameter.toString(), {headers: {Accept: 'application/json'}})
        .then(function (antwort) {
            if (!antwort.ok) throw new Error('MarketingBox delivery antwortete mit HTTP ' + antwort.status);
            return antwort.json();
        })
        .then(function (daten) {
            const boxen = ((daten && daten.payload) || []).slice(0, 3);
            if (!boxen.length) {
                if (imBackend) {
                    iwwMarketingBoxPlatzhalter(inhalt, iwwMarketingBoxLeertext(element));
                } else {
                    element.style.display = 'none';
                }
                return;
            }
            iwwMarketingBoxRender(inhalt, boxen);
        })
        .catch(function (fehler) {
            console.error('Marketingbox konnte nicht geladen werden:', fehler);
            if (imBackend) {
                iwwMarketingBoxPlatzhalter(inhalt, 'Marketingboxen konnten nicht geladen werden (' + fehler.message + ').');
            } else {
                element.style.display = 'none';
            }
        });
}

function iwwProductTeaserCardHtml(product, ctaText, darstellung, index, total) {
    const title = product.title || product.headline || '';
    const image = product.productImageUrl || '';
    const description = product.description || '';
    const amount = product.amount || '';
    const url = product.url || '';
    const label = ctaText || product.ctatext || 'Mehr erfahren';
    const informationsdienst = String(product.informationsdienst || '').trim();
    const centerLast = total > 1 && total % 2 === 1 && index === total - 1;
    const wrapperClass = centerLast ? 'xl:col-span-2 xl:mx-auto xl:w-full xl:max-w-[620px]' : '';
    const cardClass = darstellung === 'normal'
        ? 'flex h-full flex-col overflow-hidden bg-surface-background'
        : 'flex h-full overflow-hidden rounded-2xl border border-surface-border bg-surface-background p-5 shadow-[0_8px_24px_rgba(15,23,42,0.08)]';

    const imageHtml = image
        ? '<div class="flex w-full shrink-0 items-center justify-center md:w-[145px]">'
          + '<img class="h-auto max-h-[125px] w-auto max-w-[145px] rounded-3xl object-contain" src="' + iwwMarketingBoxEscape(image) + '" alt="'
          + iwwMarketingBoxEscape(title || 'Produktbild') + '" loading="lazy"/>'
          + '</div>'
        : '<div class="flex h-[125px] w-full shrink-0 items-center justify-center rounded-xl bg-surface-elevated-background text-center text-xs text-neutral-subtle md:w-[145px]">Kein Produktbild hinterlegt</div>';

    const badgeHtml = informationsdienst
        ? '<span class="inline-flex w-fit items-center rounded-full bg-primary-background px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-neutral-on-primary [--color-primary-background:var(--primary-background)] [--color-neutral-on-primary:var(--neutral-on-primary)]">'
          + iwwMarketingBoxEscape(informationsdienst) + '</span>'
        : '';

    const descriptionHtml = description
        ? '<p class="mt-2 text-sm leading-5 text-neutral-subtle">' + iwwMarketingBoxEscape(description) + '</p>'
        : '';

    const amountHtml = amount
        ? '<p class="mt-2 text-sm font-semibold text-neutral">' + iwwMarketingBoxEscape(amount) + '</p>'
        : '';

    const buttonHtml = url
        ? '<a class="inline-flex items-center justify-center rounded-full bg-primary-background px-5 py-2.5 text-sm font-semibold text-neutral-on-primary no-underline transition hover:bg-primary-background-dark [--color-primary-background:var(--primary-background)] [--color-primary-background-dark:var(--primary-background-dark)] [--color-neutral-on-primary:var(--neutral-on-primary)]" href="'
          + iwwMarketingBoxEscape(url) + '" target="_blank" rel="noopener noreferrer">'
          + iwwMarketingBoxEscape(label) + '<span class="ml-2.5 text-base leading-none">›</span></a>'
        : '<span class="inline-flex items-center justify-center rounded-full bg-accent-background px-5 py-2.5 text-sm font-semibold text-neutral-subtle">'
          + iwwMarketingBoxEscape(label) + '</span>';

    return '<div class="' + wrapperClass + '">'
        + '<article class="' + cardClass + '">'
        + '<div class="flex h-full w-full flex-col gap-5 md:flex-row md:items-center md:gap-6">'
        + imageHtml
        + '<div class="flex min-w-0 flex-1 flex-col">'
        + badgeHtml
        + '<h3 class="mt-2 text-lg font-medium leading-snug text-neutral sm:text-xl">' + iwwMarketingBoxEscape(title) + '</h3>'
        + descriptionHtml
        + amountHtml
        + '<div class="mt-4">' + buttonHtml + '</div>'
        + '</div>'
        + '</div>'
        + '</article>'
        + '</div>';
}

function iwwProductTeaserRender(element, products) {
    const inhalt = element.querySelector('.iww-product-teaser-inhalt');
    if (!inhalt) return;

    const ctaText = element.getAttribute('data-cta-text') || 'Mehr erfahren';
    const darstellung = element.getAttribute('data-darstellung') || 'kachel';
    const ausrichtung = element.getAttribute('data-ausrichtung') || 'horizontal';
    const gridClass = ausrichtung === 'vertikal'
        ? 'grid grid-cols-1 gap-6'
        : 'grid grid-cols-1 gap-6 xl:grid-cols-2';

    inhalt.innerHTML = '<div class="' + gridClass + '">'
        + products.map(function (product, index) { return iwwProductTeaserCardHtml(product, ctaText, darstellung, index, products.length); }).join('')
        + '</div>';
}

function iwwProductTeaserLade(element) {
    if (element.getAttribute('data-iww-product-teasers-initialisiert') === 'true') return;
    element.setAttribute('data-iww-product-teasers-initialisiert', 'true');

    const inhalt = element.querySelector('.iww-product-teaser-inhalt');
    if (!inhalt) return;

    const informationsdienste = element.getAttribute('data-informationsdienste') || '';
    const maxItems = Math.max(1, Math.min(12, Number.parseInt(element.getAttribute('data-max-items') || '4', 10) || 4));
    const imBackend = iwwMarketingBoxImBackend(element);
    const box = element.closest('[data-iww-product-teaser-box]') || element;

    if (informationsdienste === '') {
        if (imBackend) {
            iwwMarketingBoxPlatzhalter(inhalt, 'Im Schwerpunkt sind keine Informationsdienste hinterlegt.');
        } else {
            box.style.display = 'none';
        }
        return;
    }

    const parameter = new URLSearchParams();
    parameter.set('informationsdienste', informationsdienste);
    parameter.set('limit', String(maxItems));

    if (imBackend) iwwMarketingBoxPlatzhalter(inhalt, 'Produkte werden geladen...');

    fetch(iwwMarketingBoxBasisUrl + '/api/v1/product/delivery?' + parameter.toString(), {headers: {Accept: 'application/json'}})
        .then(function (antwort) {
            if (!antwort.ok) throw new Error('Product delivery antwortete mit HTTP ' + antwort.status);
            return antwort.json();
        })
        .then(function (daten) {
            const products = ((daten && daten.payload) || []).slice(0, maxItems);
            if (!products.length) {
                if (imBackend) {
                    iwwMarketingBoxPlatzhalter(inhalt, 'Keine ausspielbaren Produkte fuer die Informationsdienste ' + informationsdienste + ' gefunden.');
                } else {
                    box.style.display = 'none';
                }
                return;
            }
            iwwProductTeaserRender(element, products);
        })
        .catch(function (fehler) {
            console.error('Produkte konnten nicht geladen werden:', fehler);
            if (imBackend) {
                iwwMarketingBoxPlatzhalter(inhalt, 'Produkte konnten nicht geladen werden (' + fehler.message + ').');
            } else {
                box.style.display = 'none';
            }
        });
}

function initialisiereIwwProductTeaser(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-iww-product-teasers]')) iwwProductTeaserLade(scope);
    scope.querySelectorAll('[data-iww-product-teasers]').forEach(iwwProductTeaserLade);
}

function initialisiereIwwMarketingBoxen(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-iww-marketingbox]')) iwwMarketingBoxLade(scope);
    scope.querySelectorAll('[data-iww-marketingbox]').forEach(iwwMarketingBoxLade);
}

function iwwMarketingBoxObserverStarten() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    const observer = new MutationObserver(function (mutationen) {
        mutationen.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node instanceof Element) {
                    initialisiereIwwMarketingBoxen(node);
                    initialisiereIwwProductTeaser(node);
                }
            });
        });
    });

    observer.observe(document.body, {childList: true, subtree: true});
}

document.addEventListener('DOMContentLoaded', function () {
    iwwMarketingBoxTabsDelegieren();
    initialisiereIwwMarketingBoxen(document);
    initialisiereIwwProductTeaser(document);
    if (iwwMarketingBoxImBackend(document.body)) iwwMarketingBoxObserverStarten();
});
